import CropBox from "./CropBox";

export default CropBox;
